














































import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';

@Component({
	components: {
	}
})
export default class KMenu extends Vue {
	@Prop({ default: () => [] }) menuList!: Array<Record<string, unknown>>;
	@Prop({ default: 'Menu' }) readonly label!: string;
	@Prop({ default: 'label' }) readonly keyLabel!: string;
	@Prop({ default: false }) readonly disabled !: boolean;

	menuClick(item: never): void {
		this.$emit('menu-click', item);
	}

}
